import {
    booleanAttribute,
    Directive,
    ElementRef,
    HostListener,
    inject,
    input,
} from '@angular/core';
import { NgControl } from '@angular/forms';

import { latinizeStr } from '@bazis/utils';

@Directive({
    selector: '[forceLatinInput]',
    standalone: false,
})
export class ForceLatinDirective {
    private readonly ref = inject(ElementRef<HTMLInputElement>);
    private readonly ngControl = inject(NgControl);

    readonly forceLatinInput = input(false, { transform: booleanAttribute });

    @HostListener('input', ['$event'])
    onInput(_event: InputEvent): void {
        if (!this.forceLatinInput()) return;

        const input = this.ref.nativeElement as HTMLInputElement;

        const inputValue = input.value ?? '';
        const start = input.selectionStart ?? inputValue.length;
        const end = input.selectionEnd ?? inputValue.length;

        const nextInputValue = latinizeStr(inputValue.toUpperCase());
        if (nextInputValue === inputValue) return;

        input.value = nextInputValue;
        queueMicrotask(() => input.setSelectionRange(start, end));

        this.ngControl.control?.setValue(nextInputValue, { emitModelToViewChange: false });
    }
}
